import { Modal } from "react-bootstrap"

const ChangePasswordModal = ({setChangePassword, changePassword, onSubmit}) => {
    return(
        <Modal show={changePassword.show} onHide={() => setChangePassword((prev) => ({...prev, show: false}))}>
            <Modal.Header><h3 className="dialog-modal-text">Change Password</h3></Modal.Header>
            <Modal.Body>
                <form onSubmit={onSubmit}>
                    <div className="form-group mb-4">
                        <label htmlFor="form-password">Password*</label>
                        <input id="form-password" required placeholder="Enter password" type="password" className="form-control" name="password" value={changePassword.password} onChange={(e) => setChangePassword((prev) => ({...prev, password: e.target.value}))}/>
                    </div>
                    <div className="form-group mb-4">
                        <label htmlFor="form-password">Repeat Password*</label>
                        <input id="form-password" required placeholder="Repeat password" type="password" className="form-control" name="repeat-password" value={changePassword.repeat_password} onChange={(e) => setChangePassword((prev) => ({...prev, repeat_password: e.target.value}))}/>
                    </div>
                    <div className="modal-action-buttons">
                        <button type="submit" disabled={changePassword.loader} className="submit-modal-form-btn">{changePassword.loader ? <div className="button-loader"></div> : "Submit"}</button>
                        <button type="button" onClick={() => setChangePassword((prev) => ({...prev, show: false}))} className="cancel-modal-form-btn">No</button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ChangePasswordModal